import React, { useEffect } from 'react'
import { UIStore } from '../stores/UIStore'
import { colors } from '../variables'
import styled from 'styled-components'
import {
  Payoff,
  Ingress,
  SubHeader,
  ButtonMain,
  ImgSet,
  ImageBlock,
  PageWrapper,
} from '../components/Utils'
import { Container, Row, Col, Hidden } from 'react-grid-system'

import vista from '../img/photos/vista.jpg'

import skateboard from '../img/photos/skateboard.jpg'
import dog from '../img/photos/dog.jpg'
import running from '../img/photos/running.jpg'
import baby from '../img/photos/baby.jpg'
import lights from '../img/photos/lights.jpg'
import lady from '../img/photos/lady.jpg'
import couple from '../img/photos/couple.jpg'

const About = () => {
  useEffect(() => {
    UIStore.setBackgroundShade(colors.green)
    UIStore.setFooterBg(colors.green)
  }, [])

  return (
    <>
      <LandingArea />
      <HeroImg src={vista} />
      <PageWrapper style={{ backgroundColor: colors.green }}>
        <StyledContainer>
          <Row>
            <Col xs={12} sm={6}>
              <Payoff>
                2014 startade Utvecklarbolaget med idén att leverera
                spetskompetens inom frontendutveckling till organisationer och
                företag. Vi skulle tillföra något som fattades i branschen. Vi
                ville ha fokus på seniora, högpresterande utvecklare som kom
                till jobbet för att bygga framtiden, inte för sodamaskiner och
                leksaker.
              </Payoff>
            </Col>
            <Col xs={12} sm={6}>
              <StyledIngress>
                Idag är vi vad vi sa att vi skulle vara, ett företag som tillför
                nytänk, som ger konsulten merparten av förtjänsten och öppnar
                nya vägar i arbetslivet. Vi arbetar utan interna möten,
                konferenser och leksaker. Hos oss vet våra medarbetaren vad de
                skapar, till vilket pris och med vilken ersättning.
                <br />
                <br />
                Vi tror att värdet som senior konsult ligger i utmaningen att
                jobba hos några av de främsta, få bra betalt för arbetet och ha
                friheten att styra sin karriär själv. Vi tror på valfrihet och
                entreprenörskap. Därför har vi några av Sveriges mest
                konkurrenskraftiga löner och vi ger ett aktiebolag med intäkt
                till konsulten efter 3 år tillsammans med oss.
                <br />
                <br />
                Vi tror på en framtid där man jobbar med varandra, inte för
                andra.
              </StyledIngress>
            </Col>
          </Row>
        </StyledContainer>
      </PageWrapper>
      <PageWrapper style={{ backgroundColor: colors.white }}>
        <Container>
          <SpetskompetensHolder>
            <Hidden xs>
              <Col xs={12} sm={6}>
                <ImageBlock style={{ top: '-150px' }}>
                  <ImgSet img={lights} style={{ top: 60, left: -50 }} />
                  <ImgSet img={lady} style={{ top: 0, left: 270 }} />
                  <ImgSet img={couple} style={{ top: 414, left: 270 }} />
                </ImageBlock>
              </Col>
            </Hidden>
            <Col xs={12} sm={6}>
              <SubHeader shade="dark">
                Spetskompetens utöver det vanliga
              </SubHeader>
              <Ingress shade="dark" style={{ marginTop: 30 }}>
                Vi lyfter och skapar stories om våra konsulter och presenterar
                vilka de är. Vad de har jobbat med förut, vilken kund de jobbar
                med nu och vad de har åstadkommit (CV fast i storyform).
                <br />
                Vi berättar att vi använder en tredjepart som säkerställer
                konsultens kompetensnivå.
                <br />
                Vi berättar om varför en “bra matchning” är viktig. Dvs.
                Kompetens men också personlighet.
              </Ingress>
              <ButtonMain>Våra kompetenser</ButtonMain>
            </Col>
          </SpetskompetensHolder>
          <MeranlonHolder>
            <Col xs={12} sm={6}>
              <SubHeader shade="dark">
                Vi ger mer än lön – mentorskap &amp; utveckling
              </SubHeader>
              <Ingress shade="dark" style={{ marginTop: 30 }}>
                Våra konsulter får berätta om sina utvecklarresor. Hur de har
                utvecklats genom Utvecklarbolaget.
                <br />
                Vi berättar hur konsultens 3 första år kommer att se ut (målar
                upp planen och möjligheterna hos oss som bolag).
                <br />
                Vi berättar att vi gör en behovsanalys - vad som är viktigt för
                dig (Börja i rätt ände).
              </Ingress>
              <ButtonMain>Konsult se hit</ButtonMain>
            </Col>
            <Hidden xs>
              <Col xs={12} sm={6}>
                <ImageBlock style={{ top: '-35px' }}>
                  <ImgSet img={skateboard} style={{ top: 0, left: 60 }} />
                  <ImgSet img={dog} style={{ top: 145, left: 546 }} />
                  <ImgSet img={baby} style={{ top: 463, left: -5 }} />
                  <ImgSet img={running} style={{ top: 463, left: 241 }} />
                </ImageBlock>
              </Col>
            </Hidden>
          </MeranlonHolder>
        </Container>
      </PageWrapper>
    </>
  )
}

const LandingArea = () => (
  <LandingHolder>
    <Container>
      <Row>
        <Col xs={10}>
          <h1>Vi bygger framtiden - i kod, människa och bolag</h1>
        </Col>
      </Row>
    </Container>
  </LandingHolder>
)

const StyledContainer = styled(Container)`
  margin: 60px 0;

  @media (min-width: 769px) {
    margin-top: 85px;
    margin-bottom: 120px;
  }
`

const LandingHolder = styled.div`
  padding-top: 140px;
  box-sizing: border-box;
`

const HeroImg = styled.img`
  width: 100%;
  margin-top: 90px;
`

const StyledIngress = styled(Ingress)`
  margin-top: 40px;

  @media (min-width: 769px) {
    margin-top: 0;
  }
`

const SpetskompetensHolder = styled(Row)`
  padding-top: 40px;

  @media (min-width: 769px) {
    padding-top: 110px;
  }
`

const MeranlonHolder = styled(Row)`
  padding-bottom: 60px;

  @media (min-width: 769px) {
    margin-top: 350px;
    margin-bottom: 290px;
    padding-bottom: 0;
  }

  & > div:first-child {
    @media (min-width: 769px) {
      margin-top: 110px;
    }
  }
`

export default About
